// extracted by mini-css-extract-plugin
export default {"actions__wrapper":"RegistrationEmployerContract_actions__wrapper__xrjec","actions":"RegistrationEmployerContract_actions__rKSLx"};